import React from "react";
import "./Footer.css";
import { useAuth } from "../Store/AuthContext";
import { Link } from "react-router-dom";
import { ServiceFetchData } from "../APIS/FetchAPIs";
import ScrollToTop from "react-scroll-to-top";

export default function Footer() {
  const { webSetting, RendomTokenfetch } = useAuth();
  const [ServiceData] = ServiceFetchData(RendomTokenfetch);
  return (
    <>
      <footer
        className="site-footer"
        style={{ backgroundImage: `url(../images/footerbg.jpg)` }}
      >
        <div className="footeroverlay"></div>
        <div className="upper-footer">
          <div className="container-fluid">
            <div className="row">
              <div className="col col-lg-3 col-sm-6">
                <div className="widget about-widget">
                  <Link
                    to="/"
                    className="footer-logo"
                    rel="noreferrer"
                    aria-label="This is a Website Logo"
                  >
                    {webSetting.footerlogo !== "" ? (
                      <img
                        src={webSetting.footerlogo}
                        alt=""
                        className="img img-responsive"
                        loading="lazy"
                      />
                    ) : (
                      ""
                    )}
                  </Link>
                  <p>{webSetting.footer_content}</p>
                </div>
                <div className="widget social-media-widget">
                  <ul className="">
                    <li>
                      <Link
                        to={webSetting?.facebook || ""}
                        target="blank"
                        rel="noreferrer"
                        aria-label="Go to Facebook Account"
                      >
                        <i className="fa fa-facebook"></i>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={webSetting?.instagram || ""}
                        target="blank"
                        aria-label="Go to Instagram Account"
                        rel="noreferrer"
                      >
                        <i className="fa fa-instagram"></i>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={webSetting?.linkedIn || ""}
                        target="blank"
                        rel="noreferrer"
                        aria-label="Go to Linkedin Account"
                      >
                        <i className="fa fa-linkedin"></i>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={webSetting?.twitter || ""}
                        target="blank"
                        rel="noreferrer"
                        aria-label="Go to Twitter Account"
                      >
                        <i className="fa fa-twitter"></i>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col col-lg-3 col-sm-6 ps-lg-5">
                <div className="widget site-map-widget">
                  <h3>Services</h3>
                  <ul>
                    {ServiceData.length > 0
                      ? ServiceData.map((service, index) => (
                          <li key={index}>
                            <Link to={`/service/${service.slug}`}>
                              {service.title}
                            </Link>
                          </li>
                        ))
                      : ""}
                  </ul>
                </div>
              </div>

              <div className="col col-lg-2 col-sm-6 ps-lg-5">
                <div className="widget site-map-widget">
                  <h3>Useful Link</h3>
                  <ul>
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li>
                      <Link to="/about">About</Link>
                    </li>
                    <li>
                      <Link to="/services">Service</Link>
                    </li>
                    <li>
                      <Link to="/blogs">Blogs</Link>
                    </li>
                    {/* <li>
                      <Link to="/careers">Careers</Link>
                    </li> */}
                    <li>
                      <Link to="/contact">Contact</Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col col-lg-4 col-sm-6 ps-lg-5">
                <div className="widget footercontact-widget">
                  <h3>Get In Touch</h3>
                  <ul className="contact-list">
                    {webSetting.address && (
                      <li>
                        <i className="fa fa-map-marker"></i>
                        <Link to="/contact" aria-label="Site Address">
                          {webSetting?.address || ""}
                        </Link>
                      </li>
                    )}

                    <li>
                      <i className="fa fa-envelope-o"></i>
                      <Link
                        to={`mailto:${webSetting?.email || ""}`}
                        aria-label="Go to Email Account"
                      >
                        {webSetting?.email || ""}
                      </Link>
                    </li>
                    <li>
                      <i className="fa fa-phone"></i>
                      <Link
                        to={`tel:+${webSetting?.number || ""}`}
                        aria-label="Contact Number"
                      >
                        + {webSetting?.number || ""}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="copyright">
          <div className="container-fluid">
            <div className="col col-md-6">
              <p>{webSetting?.copyright || ""}</p>
            </div>
            <div className="col col-md-6">
              <ul>
                <li>
                  <Link to="/privacy-policy" aria-label="Privacy Policy">
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to="/terms-condition" aria-label="Terms & Conditions">
                    Terms & Conditions
                  </Link>
                </li>
                <li>
                  <Link to="/return-policy" aria-label="Return Policy">
                    Return Policy
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>

      <div className="fixed-tabs-Whats">
        <div className="aba-whatsphone">
          <div className="aba-whatsphone-icone">
            <Link
              target="_blank"
              to={`https://wa.me/+${
                webSetting?.whatsaap || ""
              }?text=Hi, I would like to speak to a Euracle Group`}
            >
              <strong>Whatsapp</strong>
            </Link>
          </div>
        </div>
      </div>

      <div className="fixed-tabs-mag">
        <div className="aba-whatsphone">
          <div className="aba-whatsphone-iconem">
            <Link target="_blank" to={`tel:+${webSetting?.number || ""}`}>
              <strong>Call Now</strong>
            </Link>
          </div>
        </div>
      </div>

      <ScrollToTop smooth="true" />
    </>
  );
}
